<template>
  <div :class="headerClass">
    <HeaderHome v-if="$route.name == 'Home'" />
    <HeaderMarketplace v-if="$route.name == 'Marketplace'" />
    <HeaderProfile v-if="$route.name == 'Profilo'" />

    <HeaderPunti v-if="$route.name == 'Punti'" />
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Header",
  components: {
    HeaderHome: () => import("@/components/headers/Home"),
    HeaderMarketplace: () => import("@/components/headers/Marketplace"),
    HeaderProfile: () => import("@/components/headers/Profile"),

    HeaderPunti: () => import("@/components/headers/Punti")
  },
  computed: {
    headerClass: function() {
      let h = "header-container";
      if (this.$route.meta.headerLayout == "shrink") {
        h += " shrink";
      }
      if (this.$route.meta.headerLayout == "none") {
        h = "none";
      }

      return h;
    }
  }
};
</script>

<style lang="less">
.inner {
  z-index: 2;
  position: relative;
}
.header-container {
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  background: #fff;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.1);
  min-height: 308px;
  flex: 1;
  max-height: 360px;
  transition: all 500ms;
  &.shrink {
    min-height: 100px;
    height: auto;
  }
  &.none {
    max-height: 0;
  }

  .block-title {
    h1 {
      font-size: 1.5em;
      margin: 0;
      margin-bottom: 0.5em;
    }
    p {
      line-height: 1.3em;
      font-size: 1em;
      margin: 0;
      color: #7a7978;
    }
    margin-right: auto;
    margin-left: 10px;
    text-align: left;
  }
}

.header {
  padding: 30px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  z-index: 2;

  .points {
    width: 80px;
  }
}

.bg {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>